import { model } from "core/util";

export const PlacePredictionItem = model.createModelLegacy("PlacePredictionItem", (json) => ({
    value: json.place_id,
    name: json.description,
}));
